import CollectionsIcon from '@mui/icons-material/Collections';
import Skeleton from '@mui/material/Skeleton';
import type React from 'react';
import SelectCheckbox from 'src/components/SelectCheckBox/SelectCheckBox';
import { useListViewRowContext } from '../ListViewRowContext';

const SelectCell: React.FC = () => {
  const { loading, rowType, itemId, collection, handleNavigate } = useListViewRowContext();

  if (loading) {
    return <Skeleton variant="circular" width={20} height={20} animation="wave" sx={{ mx: 'auto' }} />;
  }

  if (rowType === 'asset' && itemId) {
    return <SelectCheckbox itemId={itemId} />;
  }

  if (rowType === 'collection' && collection) {
    return (
      // biome-ignore lint/a11y/useKeyWithClickEvents: keyboard navigation handled at table row level
      // biome-ignore lint/a11y/noStaticElementInteractions: keyboard navigation handled at table row level
      <div onClick={() => handleNavigate(collection.id)}>
        <CollectionsIcon style={{ marginLeft: 9 }} />
      </div>
    );
  }

  return null;
};

export default SelectCell;
